module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Helpful Hints"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Helpful Hints ")])])])])]), _c('div', {
    staticClass: "orderedlist"
  }, [_c('ol', {
    staticClass: "arabic"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Each type of beer has a distinctive flavor profile that can enhance foods. These\n                are the basic types of beer: ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Pilsner")])]), _vm._v(" is a crisp lager with a lightly bitter\n                flavor. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Bock beer")])]), _vm._v(" is a strong, darker lager with malty\n                flavors. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Wheat beer")])]), _vm._v(" is often unfiltered, with a mellow,\n                fruity flavor. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Pale ale")])]), _vm._v(" is crisp, with a bitter, hoppy flavor.\n            ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("IPA")])]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Double IPA\n                ")])]), _vm._v("are bitter with more aggressive hops and malt flavors. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Porter")])]), _vm._v(" is a dark, medium-bodied beer with malty\n                sweet and bitter hops flavors. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Stout")])]), _vm._v(" is a dark, heavy beer with toasty coffee\n                and chocolate flavors. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Non-alcoholic, low-alcohol (3.2%), and light (low-calorie) beers can be\n                substituted for regular beer in many recipes, but the beer flavor may be less\n                pronounced. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Do not use non-alcoholic beers in baking recipes, since the yeast in regular beer\n                acts as a leavening agent. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Beer makes an excellent marinade for meats, as its enzymes have a tenderizing\n                effect. When grilling beer-marinated meats, the beer’s natural sugars help promote\n                browning and caramelizing. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Since beer doesn’t have as much acidity as wine, meats can be marinated for a\n                longer period of time (up to 48 hours) and absorb more flavor. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("When adding beer to a mixture, use a larger mixing bowl since beer can foam up\n                upon contact with other ingredients. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Once beer is added to a batter, handle it gently. Stirring too vigorously can\n                reduce the bubbles and lessen the beer’s leavening qualities. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Baked goods made with beer generally have a longer shelf life and moister texture\n                than those made without beer. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("When cooking with very bitter beers, adding a touch of brown sugar, maple syrup,\n                or honey may help balance the flavors. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("When cooking with alcoholic beer, some alcohol may remain in the dish. In general,\n                the longer a dish is cooked, the less alcohol remains. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Because even small amounts of alcohol can be a problem for some people, advise\n                guests if a dish has been prepared with beer. ")])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "d0e62",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Use caution when cooking with beer in foods that will be frozen, as the alcohol\n                can inhibit the freezing process. ")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c97806","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 66
// module chunks = 0